import { Controller } from "@hotwired/stimulus"
import StarRating from 'star-rating.js'

export default class extends Controller {
  // static targets = ["toggleable"];

  connect() {
    console.log("Drawer Review controller connected");
    this.initStarRating()
  }

  toggle(event) {
    event.preventDefault()
    console.log("Toggle drawer review");
    document.getElementById('review_form').classList.toggle('hidden')
  }

  submit(event) {
    event.preventDefault()
    // Проставляем рейтинги
    document.getElementById('review_cleanliness').value = document.getElementsByClassName('gl-star-rating--stars')[0].getAttribute('data-rating')
    document.getElementById('review_maintenance').value = document.getElementsByClassName('gl-star-rating--stars')[1].getAttribute('data-rating')
    document.getElementById('review_communication').value = document.getElementsByClassName('gl-star-rating--stars')[2].getAttribute('data-rating')
    document.getElementById('review_convenience').value = document.getElementsByClassName('gl-star-rating--stars')[3].getAttribute('data-rating')
    document.getElementById('review_accuracy').value = document.getElementsByClassName('gl-star-rating--stars')[4].getAttribute('data-rating')

    document.getElementById('form_for_review').submit()
  }

  initStarRating() {
    new StarRating('.star-rating-cleanliness', {
      totalStars: 5,
      starSize: 25,
      tooltip: 'Выберите рейтинг',
      clearable: true,
      emptyColor: 'lightgray',
      hoverColor: 'gold',
      activeColor: 'gold',
      useGradient: false,
      disableAfterRate: false,
    });

    new StarRating('.star-rating-maintenance', {
      totalStars: 5,
      starSize: 25,
      tooltip: 'Выберите рейтинг',
      clearable: true,
      emptyColor: 'lightgray',
      hoverColor: 'gold',
      activeColor: 'gold',
      useGradient: false,
      disableAfterRate: false
    });
    new StarRating('.star-rating-communication', {
      totalStars: 5,
      starSize: 25,
      tooltip: 'Выберите рейтинг',
      clearable: true,
      emptyColor: 'lightgray',
      hoverColor: 'gold',
      activeColor: 'gold',
      useGradient: false,
      disableAfterRate: false
    });
    new StarRating('.star-rating-convenience', {
      totalStars: 5,
      starSize: 25,
      tooltip: 'Выберите рейтинг',
      clearable: true,
      emptyColor: 'lightgray',
      hoverColor: 'gold',
      activeColor: 'gold',
      useGradient: false,
      disableAfterRate: false
    });
    new StarRating('.star-rating-accuracy', {
      totalStars: 5,
      starSize: 25,
      tooltip: 'Выберите рейтинг',
      clearable: true,
      emptyColor: 'lightgray',
      hoverColor: 'gold',
      activeColor: 'gold',
      useGradient: false,
      disableAfterRate: false
    });
  }
}
